import { defineStore } from 'pinia'

export const useAuthStore = defineStore('authStore', {
    state: () =>({
        token: null,
        user: null,
        isUserLoggedIn: false,
        roles: [],
        gmswitch: false
    }),
    persist: true,
    actions: {
        async setToken(token,user,roles){
            this.token = token
            this.user = user
            if(token){
                this.isUserLoggedIn = true
            }
            this.roles = roles
        },
        async setGmswitch(){
            this.gmswitch = !this.gmswitch
            //console.log("GMSwitch is "+this.gmswitch)
        }
    }
    
})